import type { ShadowEffect } from '@/components/canvas/document/publicTypes';
import { parseShadowColor, shadowColorToRgba } from '../color/shadowColor';

/** 阴影在属性面板中的可编辑结构（颜色拆为 hex + 透明度） */
export interface AppearanceShadowValue {
  type: 'drop' | 'inner';
  colorHex: string;
  /** 颜色 alpha 0–1 */
  colorOpacity: number;
  offsetX: number;
  offsetY: number;
  blur: number;
  spread: number;
}

export const DEFAULT_APPEARANCE_SHADOW: AppearanceShadowValue = {
  type: 'drop',
  colorHex: '#6E6E6E',
  colorOpacity: 0.5,
  offsetX: 0,
  offsetY: 4,
  blur: 19,
  spread: 0,
};

export function shadowEffectToAppearanceValue(shadow: ShadowEffect): AppearanceShadowValue {
  const { hex, opacity } = parseShadowColor(shadow.color);
  return {
    type: shadow.type,
    colorHex: hex,
    colorOpacity: opacity,
    offsetX: shadow.offsetX,
    offsetY: shadow.offsetY,
    blur: shadow.blur,
    spread: shadow.spread ?? 0,
  };
}

export function appearanceShadowToEffect(value: AppearanceShadowValue): ShadowEffect {
  return {
    type: value.type,
    color: shadowColorToRgba(value.colorHex, value.colorOpacity),
    offsetX: value.offsetX,
    offsetY: value.offsetY,
    blur: value.blur,
    spread: value.spread,
  };
}
